/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    SubaccountActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchSubaccountsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUBACCOUNT_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SubaccountActions.receiveSubaccounts))
);

export const fetchSubaccountEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUBACCOUNT_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SubaccountActions.receiveSubaccount))
);

export const updateSubaccountEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUBACCOUNT_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SubaccountActions.updatedSubaccount))
);

export const deleteSubaccountEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUBACCOUNT_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SubaccountActions.deletedSubaccount))
);

export const createSubaccountEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUBACCOUNT_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, SubaccountActions.createdSubaccount))
);

export const detachSubaccountEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.SUBACCOUNT_DETACH && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, SubaccountActions.detachedSubaccount))
);
